/**
 * Which parent rows on the rail have their sub-items folded away. Parents start
 * open; folding is a per-device view preference, so it lives in localStorage
 * rather than in the synced rail layout.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface RailCollapseState {
  /** Ids of the parent rows whose sub-items are hidden. */
  folded: string[];
  toggleFolded: (id: string) => void;
}

/** Shared by every parent row's chevron. */
export const useRailCollapseStore = create<RailCollapseState>()(
  persist(
    set => ({
      folded: [],
      toggleFolded: id =>
        set(state => ({
          folded: state.folded.includes(id)
            ? state.folded.filter(f => f !== id)
            : [...state.folded, id],
        })),
    }),
    { name: 'rail-folded-parents' }
  )
);
